import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { logger } from "redux-logger";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authorizationSlice from "./authorization";
import dynamicDataSlice from "./dynamicData";
import localeSlice from "./localeSlice";
import staticDataSlice from "./staticData";
import chatSlice from "./chatSlice";
import shopSlice from "./shopSlice";

const persistConfig = {
  key: "Scraption-Admin",
  version: 1,
  storage,
};

const reducer = {
  auth: authorizationSlice,
  localization: localeSlice,
  staticData: staticDataSlice,
  dynamicData: dynamicDataSlice,
  chat: chatSlice,
  shop: shopSlice,
};

const rootReducer = combineReducers(reducer);
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(logger),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
